<script setup lang="ts">
import { computed, ref } from "vue"
import type { MediaFormData } from "../media/media"

interface Candidate {
  id: string
  filename: string
  draft: MediaFormData
}

const props = defineProps<{
  candidates: Candidate[]
}>()

const emit = defineEmits<{
  select: [id: string]
}>()

const open = ref(false)

function hasAnyValue(draft: MediaFormData): boolean {
  return !!draft.copyright
    || !!draft.copyrightUrl
    || !!draft.license
    || !!draft.licenseUrl
    || !!draft.sourceUrl
    || draft.watermark === true
    || draft.tags.length > 0
    || draft.companies.length > 0
    || draft.gameSeries.length > 0
    || draft.games.length > 0
    || draft.gameConsoles.length > 0
}

const visibleCandidates = computed(() => props.candidates.filter(c => hasAnyValue(c.draft)))

function onSelect(id: string): void {
  emit("select", id)
  open.value = false
}
</script>

<template>
  <div class="relative inline-block">
    <button
      data-testid="copy-from-trigger"
      type="button"
      class="btn btn-sm"
      @click="open = !open"
    >
      📋 Von ▾
    </button>

    <div
      v-if="open"
      class="absolute right-0 mt-2 w-72 bg-white shadow-lg rounded-md border border-gray-200 z-10"
    >
      <div class="p-2">
        <div v-if="visibleCandidates.length === 0" class="text-sm text-gray-500 p-3 text-center">
          Keine Quellen mit Werten
        </div>
        <ul v-else class="max-h-80 overflow-y-auto">
          <li
            v-for="c of visibleCandidates"
            :key="c.id"
            :data-testid="`copy-from-option-${c.id}`"
            class="cursor-pointer px-3 py-2 hover:bg-gray-100 rounded text-sm"
            @click="onSelect(c.id)"
          >
            {{ c.filename }}
          </li>
        </ul>
      </div>
    </div>
  </div>
</template>
